import { createSelector } from 'reselect';
import { RootState, SessionsState } from '../state';
import { JobPhase } from '../../shared/models/jobs';
import { isTodayFutureTime, isTodayOrBefore } from '../../shared/utils/date-utils';

export const selectSessionState = (state: RootState) => state?.sessions;

export const selectSessions = createSelector(
  selectSessionState,
  (state: SessionsState) => state?.data
);

export const selectActiveJobsFromSessions = createSelector(
  selectSessionState,
  (state: SessionsState) => {
    const sessions = state?.data;
    const allJobs = sessions?.sort((a, b) => a.created_time - b.created_time)?.reduce((acc, session) => {
      if (session?.tasks?.length > 0) {
        acc.push(...(session.tasks?.map(t => ({...t.task, rank: t.rank})))?.sort((a, b) => a.rank - b.rank));
      }
      return acc;
    }, []);
    return allJobs?.filter((job) => {
      return job.phase && ![JobPhase.Feedback, JobPhase.Cancelled, JobPhase.Completed].includes(job.phase) && isTodayOrBefore(job.due_time);
    });
  }
);

export const selectNotActiveJobsFromSession = createSelector(
  selectSessionState,
  (state: SessionsState) => {
    const sessions = state?.data;
    const allJobs = sessions?.sort((a, b) => a.created_time - b.created_time)?.reduce((acc, session) => {
      if (session?.tasks?.length > 0) {
        acc.push(...(session.tasks?.map(t => ({...t.task, rank: t.rank})))?.sort((a, b) => a.rank - b.rank));
      }
      return acc;
    }, []);
    return allJobs?.filter((job) => {
      return [JobPhase.Feedback, JobPhase.Cancelled, JobPhase.Completed].includes(job.phase) && isTodayFutureTime(job.completed_time);
    });
  }
);

export const selectJobsFromSessions = createSelector(
  selectSessionState,
  (state: SessionsState) => {
    const sessions = state?.data;
    const allJobs = sessions?.sort((a, b) => a.created_time - b.created_time)?.reduce((acc, session) => {
      if (session?.tasks?.length > 0) {
        acc.push(...(session.tasks?.map(t => ({...t.task, rank: t.rank})))?.sort((a, b) => a.rank - b.rank));
      }
      return acc;
    }, []);
    return allJobs;
  }
);

